import { Component } from 'react';
// The State App Management
import store from "../../../../store/index";

/* Features Mods - Player <==> Library */
import RouteRoot from "../../route/Root";
import TooltipRoot from "../../tooltip/Root";
import ShortCutRoot from "../../shortcut/Root";
import NavControlRoot from "../../nav-control/Root";
import AutomixRoot from "../../automix/Root";
import PartyModeRoot from "../../partymode/Root";

const extender = (...parts) => parts.reduce((root, feature) => feature(root, store), Component);

/* Public Methods Available For LRoot */
class CustomRoot extends extender(
  RouteRoot,
  TooltipRoot,
  ShortCutRoot,
  NavControlRoot,
  AutomixRoot,
  PartyModeRoot
) {}

export default CustomRoot;
